import { DataService, Message } from "@/service";
import {UtilService,WinForm, ApiService} from '@/libs';

// 文件上传参数
interface UploadInter {
	files: Array<any>; // 文件数组
	limit: number; // 同时上传的数量
	oneDoneFn: Function; // 一个文件上传完成后执行的函数
	getUploadAdressFn: Function;
}

// 文件上传
export class FileUploadObs {
	static queue: Array<any> = [];
	static stack: Array<any> = [];
	static oneDoneFn: Function;
	static getUploadAdressFn: Function;
	// 上传文件
	static uploadFiles({ files, limit, oneDoneFn ,getUploadAdressFn}: UploadInter) {
		this.queue = [];
		this.stack = [];
		this.oneDoneFn = oneDoneFn;
		this.getUploadAdressFn = getUploadAdressFn;
		limit = limit || 5;

		this.queue.push(...files);
		let len = files.length > limit ? limit : files.length;
		let pushList = this.queue.splice(0, len);
		this.stack.push(...pushList);
		this.stack.forEach((item) => {
			this.upFile(item);
		});
		return new Promise((resolve, reject) => {
			let timer: any = setInterval(() => {
				if (this.queue.length == 0 && this.stack.length == 0) {
					resolve(files);
					clearInterval(timer);
				}
			}, 100);
		});
	}

	static getFileHash(path: string) {
		return new Promise((resolve) => {
			// 大文件上传会长时间卡顿
			setTimeout(() => {
				let hash = WinForm.md.getFileHash(path); // 同步获取fileHash
				resolve(hash);
			}, 50);
		});
	}

	private static oneDone(doneFile: any) {
		if (this.oneDoneFn) this.oneDoneFn(doneFile);

		let index = this.stack.findIndex((item) => item.Path === doneFile.Path);
		this.stack.splice(index, 1); // 删掉已完成
		if (this.queue.length !== 0) {
			let nextFile = this.queue.splice(0, 1)[0]; // 截取file
			this.stack.push(nextFile); // 推入stack
			this.upFile(nextFile);
		}
	}

	private static async upFile(file: any) {
		try {
			file.UploadKey = UtilService.Guid();
			// 判断是否上传
			if (file.FileServerPath) {
				this.upFileProgress(file.UploadKey, 100, "", "MD_COMPLETE", "");
			} else {
				this.upFileProgress(file.UploadKey, 0, "", "MD_UPLOAD", ""); // 初始
				if (file.ScreenShoot) {
					file.FileHash = WinForm.md.getMD5Hash(file.Path);
				} else {
					file.OldFileHash = file.FileHash; // 缓存本地的hash
					file.FileHash = await this.getFileHash(file.Path);
				}
				let params = {
					FilePath: file.Path,
					FileHash: file.FileHash,
					FileExt: file.FileExt,
					uploadKey: file.UploadKey,
				};
				//let res = await FileUpload.existFile("product", params, this.upFileProgress)
				let res:any = await this._ossSignature("product", params, this.upFileProgress);
				file.FileServerPath = res.FileServerPath;
				file.FileBucket = res.FileBucket;
				//if (!res.hasOwnProperty("uploadId")) {
				// 如果没有返回ID 说明已经上传过了；  // 没有上传过，走oss
				this.upFileProgress(file.UploadKey, 100, "", "MD_COMPLETE", "");
				//}
			}
		} catch (error) {
			FileUploadObs.upErrorHandle(file, error.Message);
		}
	}

	private static upErrorHandle(file: any, errMsg: string) {
		file.IsError = true;
		file.ErrorMsg = errMsg;
		FileUploadObs.oneDone(file);
	}

	private static upFileProgress(key: any, progress: any, speed: any, status: any, statusDesc: any, totalSize?: any) {
		// console.log("file：", key, progress, speed, status, statusDesc, totalSize);
		let file = FileUploadObs.stack.find((file) => file.UploadKey === key);
		// 上传出错；
		if (status === "MD_ERROR") {
			Message.error(statusDesc);
			clearInterval(file.timer);
			FileUploadObs.upErrorHandle(file, statusDesc);
		} else {
			if (file && file.hasOwnProperty("Percent")) {
				// 平滑进度a
				if (file.timer) clearInterval(file.timer);
				file.timer = setInterval(() => {
					if (progress > file.Percent) {
						file.Percent += 1;
					} else {
						clearInterval(file.timer);
						file.timer = null;
						if (file.Percent >= 100 && status == "MD_COMPLETE") {
							if (!file.FileSize && totalSize) file.FileSize = totalSize;
							else FileUploadObs.oneDone(file);
						}
					}
				}, 10);
			} else {
				// if (progress == 100 && status == "MD_COMPLETE") {
				// 	if (!file.FileSize && totalSize) file.FileSize = totalSize;
				// 	FileUploadObs.oneDone(file);
				// }
			}
		}
	}

	// static async existFile(category: any, file: any, progress: Function, priv: boolean = false) {
	// 	try {
	// 		return await DataService.get(`${ApiService.Host}/file/exists?hash=${file.FileHash}`);
	// 	} catch (e) {
	// 		return await this._ossSignature(category, file, progress, priv);
	// 	}
	// }

	static async _ossSignature(category: any, _file: any, progress: Function, priv: boolean = false) {
		//获取oss上传签名
		let type = FileUploadObs.getFileType(_file.FileExt.toLowerCase());
		let res = await DataService.post(`${ApiService.EngineerApi}/obs/putUrlSignature?category=${category}&key=${_file.FileHash}&priv=${priv}`, {
			ContentType: type,
		});
		let uploadId = WinForm.md.upload(_file.FilePath, res.data, type, progress, _file.uploadKey);
		return new Promise((resolve)=> {
			let file: any = {
				FileServerPath: res.data.options.key,
				FileBucket: res.data.options.bucket,
				uploadId,
			};
			//@ts-ignore
			if(!window.md.askUploadEnd) {
				let onceTime:any = setTimeout(()=> {
					clearTimeout(onceTime);
					onceTime = null;
					this.getUploadAdressFn(res.data)
					resolve(file);
				},600)
				
			}else {
				let timer:any = setInterval(()=> {
					//@ts-ignore
					const result =  window.md.askUploadEnd(uploadId);
					if(result === false || result === 'false') {
						clearInterval(timer);
						timer = null;
						this.getUploadAdressFn(res.data)
						resolve(file)
					}
				},100)
			}
			
		})
		// if(uploadId) {
		// 	this.getUploadAdressFn(res.data)
		// }else{
		// 	this.getUploadAdressFn();
		// }
		// let file: any = {
		// 	FileServerPath: res.options.key,
		// 	FileBucket: res.options.bucket,
		// 	uploadId,
		// };
		
		// return file;
	}

	static  getFileType(FileExt: string) {
		switch (FileExt) {
			case ".doc":
			case ".rtf":
				return "application/msword";
			case ".pdf":
				return "application/pdf";
			case ".docx":
				return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
			case ".xls":
				return "application/vnd.ms-excel";
			case ".xlsx":
				return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
			case ".ppt":
				return "application/vnd.ms-powerpoint";
			case ".pptx":
				return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
		}
	}
}
